import React from 'react'
import PropTypes from 'prop-types'

const DisabledOverlay = ({ 
  show = false, 
  message = null,
  backgroundColor = 'rgba(0, 0, 0, 0.4)',
  borderRadius = '4px',
  textStyle = {}
}) => {
  if (!show) return null

  const baseStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor,
    zIndex: 10,
    pointerEvents: 'all',
    borderRadius: message ? undefined : borderRadius, 
  }

  const textOverlayStyle = {
    ...baseStyle,
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    color: 'white',
    fontSize: '18px',
    fontWeight: 'bold',
    paddingTop: '40px',
    textShadow: '1px 1px 2px rgba(0, 0, 0, 0.8)',
    ...textStyle
  }

  if (message) {
    return (
      <div style={textOverlayStyle}>
        {message}
      </div>
    )
  }

  return <div style={baseStyle} />
}

DisabledOverlay.propTypes = {
  show: PropTypes.bool,
  message: PropTypes.string,
  backgroundColor: PropTypes.string,
  borderRadius: PropTypes.string,
  textStyle: PropTypes.object,
}

export default DisabledOverlay